module.exports = __webpack_public_path__ + "static/greenest-terminal-729dcc76ecaf1c1ce14b7291d644047e.jpg";